'use strict';

import { Entity } from '../Entity';

export class IndSocial extends Entity {
  protected indSocId;

  protected ind;

  protected indSocial;

  protected indSocialStartDate;

  protected dlNumber;

  protected householdIncome;

  protected incomeLastReview;

  protected IRMAA;

  protected LEP;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indSocId = data.indSocId;

    this.ind = data.ind;

    this.indSocial = data.indSocial;

    this.dlNumber = data.dlNumber;

    this.householdIncome = data.householdIncome;

    this.IRMAA = data.IRMAA;

    this.LEP = data.LEP;

    if (data.incomeLastReview) {
      const incomeLastReview = data.incomeLastReview.date.split(' ')[0].split('-');
      this.incomeLastReview =
        incomeLastReview[1] + '/' + incomeLastReview[2] + '/' + incomeLastReview[0];
    }

    if (data.indSocialStartDate) {
      const indSocialStartDate = data.indSocialStartDate.date.split(' ')[0].split('-');
      this.indSocialStartDate =
        indSocialStartDate[1] + '/' + indSocialStartDate[2] + '/' + indSocialStartDate[0];
    }
  }

  public getIndSocId() {
    return this.indSocId;
  }

  public setIndSocId(indSocId) {
    this.indSocId = indSocId;

    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;

    return this;
  }

  public getIndSocial() {
    return this.indSocial;
  }

  public setIndSocial(indSocial) {
    this.indSocial = indSocial;

    return this;
  }

  public getIndSocialStartDate() {
    return this.indSocialStartDate;
  }

  public setIndSocialStartDate(indSocialStartDate) {
    this.indSocialStartDate = indSocialStartDate;

    return this;
  }

  public getDlNumber() {
    return this.dlNumber;
  }

  public setDlNumber(dlNumber) {
    this.dlNumber = dlNumber;

    return this;
  }

  public getHouseholdIncome() {
    return this.householdIncome;
  }

  public setHouseholdIncome(householdIncome) {
    this.householdIncome = householdIncome;

    return this;
  }

  public getIncomeLastReview() {
    return this.incomeLastReview;
  }

  public setIncomeLastReview(incomeLastReview) {
    this.incomeLastReview = incomeLastReview;

    return this;
  }

  public getIRMAA() {
    return this.IRMAA;
  }

  public setIRMAA(IRMAA) {
    this.IRMAA = IRMAA;

    return this;
  }

  public getLEP() {
    return this.LEP;
  }

  public setLEP(LEP) {
    this.LEP = LEP;

    return this;
  }
}
